import { ModuleWithProviders, NgModule } from '@angular/core';
import { EnvironmentVariables } from './environment-variables';
import { AuthModule } from './auth/auth.module';
import { LoggerModule } from './logger/logger.module';
import { LastUrlModule } from './last-url/last-url.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { SignalRModule } from './signal-r/signal-r.module';
import { AddressModule } from './address/address.module';
import { ChatModule } from './chat/chat.module';
import { MfaModule } from './mfa/mfa.module';

@NgModule({
  declarations: [],
  imports: [
    AuthModule,
    LoggerModule,
    LastUrlModule,
    LayoutModule,
    SharedModule,
    SignalRModule,
    AddressModule,
    ChatModule,
    MfaModule,
  ],
  exports: [
    AuthModule,
    LoggerModule,
    LastUrlModule,
    LayoutModule,
    SharedModule,
    SignalRModule,
    AddressModule,
    ChatModule,
    MfaModule,
  ],
})
export class AdrenoCommonModule {
  public static forRoot(
    environment: EnvironmentVariables
  ): ModuleWithProviders<AdrenoCommonModule> {
    return {
      ngModule: AdrenoCommonModule,
      providers: [{ provide: EnvironmentVariables, useValue: environment }],
    };
  }
}
